import { useQuery } from '@tanstack/react-query';
import { useContext, useMemo } from 'react';

import { UserContext } from '~/components/providers/UserProvider';
import { getReceivedGroupInvites } from '~/services/marketplace/marketplace-service.service.api';

import { GroupEntriesQueryKeys } from '../constants/query';

export const usePendingReceivedGroupInvites = () => {
  const { user } = useContext(UserContext);
  const userId = user?.id ?? '';
  const { data, isLoading, isError, refetch } = useQuery({
    enabled: Boolean(userId),
    queryKey: GroupEntriesQueryKeys.receivedInvites(userId, 'pending'),
    queryFn: ({ signal }) => getReceivedGroupInvites('pending', signal),
    retry: false,
  });

  const pendingInvites = useMemo(
    () => data?.filter((invite) => invite.status === 'pending') ?? [],
    [data]
  );

  return {
    pendingInvites,
    isLoading,
    isError,
    refetch,
  };
};
